import { Rating } from "@mui/material";

const LeadRating = ({ rating, readOnly, size = "large", onChange }) => {
  return (
    <Rating
      value={rating}
      readOnly={readOnly}
      size={size}
      onChange={(event, newValue) => {
        onChange(newValue);
      }}
    />
  );
};
export default LeadRating;
